import { render } from "./Header.vue?vue&type=template&id=7ef24a56&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=7ef24a56&scoped=true&lang=css"

import exportComponent from "/root/www/logbuch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef24a56"]])

export default __exports__